import { InferFormValues, JsonFormSchemaV2 } from '../../component-library/FormComponent/types'
import { useCallback } from 'react'
import { useFiltersLayout } from '../FiltersLayoutContext'
import { useAppPageState } from '../useAppPageState'
import { UnPinnedFilterContent } from './UnpinnedFilterContent'
import { useGetPageFilters } from './useGetPageFilters'
import { useSubmitPageFilters } from './useSubmitPageFilters'

interface FormFilterContentProps {
  /** When true, outer scroll is the popover body (matches tile filter popover). */
  embedInPopover?: boolean
}

export function FormFilterContent({ embedInPopover = false }: FormFilterContentProps) {
  const { data } = useGetPageFilters()
  const { unPinnedFilters, pinFilter } = useFiltersLayout()
  const { submitFilters, defaultsFromPersisted } = useSubmitPageFilters()
  const { dismissFilterPopover } = useAppPageState()

  const submitHandler = useCallback(
    (formValues: InferFormValues<JsonFormSchemaV2>) => {
      submitFilters(formValues)
      if (embedInPopover) {
        // Let the Apply click finish before unmounting the popover content.
        // Otherwise the tail end of the same click can hit the trigger below and reopen it.
        window.setTimeout(() => {
          dismissFilterPopover()
        }, 0)
      }
    },
    [embedInPopover, dismissFilterPopover, submitFilters]
  )

  return (
    <UnPinnedFilterContent
      submitHandler={submitHandler}
      schema={data.data}
      resetDefaults={defaultsFromPersisted}
      pinFilter={pinFilter}
      unPinnedFilters={unPinnedFilters}
      embedInPopover={embedInPopover}
    />
  )
}
